import { useCallback } from 'react';
import type { GoodsOption } from 'shared/src/api';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';
import { useGoodsDetail } from '../../../queries/useGoodsDetail';
import { bridge } from 'shared/src/utils';
import { useSelectOptionContext } from '../context/SelectOptionsContext';

export const useLogClickAddToCart = (params: { selected: GoodsOption[] }) => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();
  const { data: goodsDetail } = useGoodsDetail();
  const { mode: selectOptionMode } = useSelectOptionContext();

  return useCallback(() => {
    const totalOptionPrice = params.selected.reduce(
      (val, cur) => val + cur.price * cur.stock,
      0,
    );

    const isDelayPercent =
      (params.selected.filter(option => option.is_delayed).length /
        params.selected.length) *
      100;

    logGoodsAnalytics({
      name: 'CLICK_ADD_TO_CART',
      analytics: {
        ADD_GOODS_COUNT: params.selected.length,
        FOLDER_TYPE:
          goodsDetail?.goods.like?.folder_sno !== 0 ? '제작서립' : '기본서랍',
        TOTAL_OPTIONS_PRICE: totalOptionPrice,
        IS_DELAY_PERCENT: Math.ceil(isDelayPercent),
        ...(selectOptionMode === 'gift' ? { KIND: 'GIFT' } : {}),
      },
    });

    params.selected.forEach(selected => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_ADD_TO_CART_PER_OPTION',
        analytics: {
          EVENT_TYPE: 'CLICK_ADD_TO_CART_PER_OPTION',
          ADD_GOODS_OPTION_DELIVERY_TYPE: selected.delivery_type,
          GOODS_SNO: goodsDetail?.goods.sno.toString(),
          IS_DELAY: selected.is_delayed ? '1' : '0',
          OPTION_SNO: selected.sno.toString(),
          SCREEN: 'GOODS_DETAIL',
          ...(selectOptionMode === 'gift' ? { KIND: 'GIFT' } : {}),
        },
      });
    });
  }, [
    goodsDetail?.goods.like?.folder_sno,
    goodsDetail?.goods.sno,
    logGoodsAnalytics,
    params.selected,
    selectOptionMode,
  ]);
};
